import { makeStyles, Theme } from '@material-ui/core';
import { Coords } from 'google-map-react';
import React, { useMemo } from 'react'
import { getLocationAfterChangingMarker, ILocation } from './locationHelpers';
import Map from '../../../Map/Map';
import Marker from '../../../Map/Marker';

interface Props {
    isReadOnly?: boolean
    value: ILocation | null
    updateCurrentLocation?: (value: ILocation | null) => void
}

const styles = (theme: Theme) => ({
    mapContainer: {
        width: '100%',
        height: 160,
        marginTop: 12,
        borderRadius: 4,
        overflow: 'hidden',
    },
});

const useStyles = makeStyles(styles)



export const LocationMap = (props: Props, ref: any) => {
    const {value, updateCurrentLocation, isReadOnly} = props
    const classes = useStyles()
    const currectLang = "en-US"

    const location = useMemo(() => {
        if(!value || !value?.geoLocation?.lat || !value?.geoLocation?.lon) return undefined
        return { 
                lat: value.geoLocation.lat, 
                lng: value.geoLocation.lon 
            }

    }, [value])

    const onClickMap = async (newMarker: Coords) => {
        if(isReadOnly) return
        const newLocation = await getLocationAfterChangingMarker(newMarker)
        updateCurrentLocation?.(newLocation)
    }

    return <Map isReadOnly={isReadOnly} center={location} lang={currectLang} classes={{ container: classes.mapContainer }} onClick={onClickMap} >
        {location ? <Marker location={location} lat={location.lat} lng={location.lng} /> : null}
    </Map>
}